"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkValidity = void 0;

var yup_1 = require("yup");

var ramda_1 = require("ramda");

exports.checkValidity = ramda_1.curry(function (schema, dto) {
  try {
    schema.validateSync(dto, {
      abortEarly: false
    });
  } catch (error) {
    if (error instanceof yup_1.ValidationError) {
      return {
        error: error
      };
    }

    throw error;
  }

  return {
    error: null
  };
});